import React from 'react';
import { Link } from 'react-router-dom';
import LegalDocumentLayout from './LegalDocumentLayout';

const CookiesPolicy = () => (
  <LegalDocumentLayout title="Cookies Policy" lastUpdated="22 September 2026">
    <p>
      This Cookies Policy explains how TenantScore uses cookies and similar technologies on our website
      and related services. It should be read together with our <Link to="/privacy">Privacy Notice</Link>.
    </p>

    <h2>1. What cookies and similar technologies are</h2>
    <p>
      Cookies are small text files stored on your device. We also use similar technologies such as browser
      local storage. These help the Platform function, remember choices you make, and (if you allow it)
      understand how the site is used.
    </p>

    <h2>2. How we use them</h2>
    <ul>
      <li>
        <strong>Strictly necessary:</strong> keep you signed in, protect your session, and remember
        security-related choices. Authentication tokens are stored in your browser (localStorage) so the
        Platform can work. These are required and are not optional in the cookie popup.
      </li>
      <li>
        <strong>Preferences:</strong> remember interface choices where we offer them.
      </li>
      <li>
        <strong>Analytics (non-essential):</strong> Firebase Analytics (Google) measures page views and
        product usage so we can improve TenantScore. This only runs if you accept non-essential cookies.
      </li>
      <li>
        <strong>Notifications:</strong> if you allow browser notifications, Firebase Cloud Messaging may
        store a device token so we can send push alerts.
      </li>
    </ul>

    <h2>3. Your choices</h2>
    <p>
      When you first visit, we ask you to accept or reject non-essential cookies. You can change that
      choice at any time using Cookie settings in the footer. Rejecting non-essential cookies does not
      stop you from using TenantScore; it only turns off analytics measurement.
    </p>

    <h2>4. Third parties</h2>
    <p>
      Google/Firebase may set their own cookies or identifiers when Analytics or Messaging is enabled.
      Use of those services is also subject to Google&apos;s policies. If you sign in with Google, Google
      may set cookies as part of that sign-in flow.
    </p>

    <h2>5. How to control cookies in your browser</h2>
    <p>
      You can also block or delete cookies through your browser settings. Strictly necessary storage is
      required for login. Blocking all storage may prevent you from staying signed in.
    </p>

    <h2>6. Changes</h2>
    <p>
      We may update this policy from time to time. When we do, we will change the &quot;Last updated&quot;
      date on this page.
    </p>

    <h2>7. Contact</h2>
    <p>If you have questions about this Cookies Policy, contact TenantScore:</p>
    <ul>
      <li>Phone: +254 113 886 814</li>
      <li>Website: tenantscore.co.ke</li>
    </ul>
  </LegalDocumentLayout>
);

export default CookiesPolicy;
